import { EXPRESS_API } from 'configs/api/expressApi';
import { FormikHelpers } from 'formik';
import { useToastError } from 'lib/hooks/useToastError';
import { useMutation, useQueryClient } from 'react-query';
import { quickFilterKeys } from './quickFilterKey';

interface IQuickFilterParas {
  payload: {
    title: string;
    rules: any;
  };
  actions: {
    resetFormikValues: () => void;
    setShowSaveFilters: React.Dispatch<React.SetStateAction<boolean>>;
    formik: FormikHelpers<any>;
  };
}

const createQuickFilter = async (params: IQuickFilterParas): Promise<any> => {
  return (await EXPRESS_API.post(`quick-filters`, { ...params.payload })).data;
};

export const useQuickQueryMutation = () => {
  const { showError } = useToastError();
  const queryClient = useQueryClient();
  return useMutation(createQuickFilter, {
    onSuccess: (_data, variables) => {
      const { resetFormikValues, setShowSaveFilters, formik } =
        variables.actions;
      resetFormikValues();
      setShowSaveFilters(false);
      formik.resetForm();
      queryClient.invalidateQueries(quickFilterKeys.all());
    },
    onError: err => showError(err),
  });
};
